module.exports = __webpack_public_path__ + "img/role_4_name.c77552e1.png";